import { memo } from "react";
import { StyleProp, ViewStyle } from "react-native";
import Animated from "react-native-reanimated";
import Loading from "src/components/Loading";
import useAnimatedOpacityStyle from "src/hooks/useAnimatedOpacityStyle";
import usePhotoDetailStore from "../../../stores/usePhotoDetailStore";

const PhotoLoading = ({ style }: { style?: StyleProp<ViewStyle> }) => {
	const isCurPhotoLoading = usePhotoDetailStore(
		(state) => state.isWaitingForCurPhotoLoad || state.isWaitingForCurPhotoDetailedLoad,
	);
	const animatedStyle = useAnimatedOpacityStyle(+isCurPhotoLoading);

	return (
		<Animated.View style={[style, animatedStyle]}>
			<Loading />
		</Animated.View>
	);
};
export default memo(PhotoLoading);
